module.exports = __webpack_public_path__ + "static/media/notification-warning.69bd79e4.svg";